import { FontIcon, Stack, Text } from '@fluentui/react'
import { KrStatus } from './krFormat'

type KrStatusBadgeProps = {
  status: KrStatus
}

const BADGES: Record<KrStatus, { label: string; icon: string; color: string }> = {
  met: { label: 'Met', icon: 'CompletedSolid', color: '#5B8A72' },
  'not-met': { label: 'Not met', icon: 'StatusErrorFull', color: '#D4775B' },
  'in-progress': { label: 'Not yet met', icon: 'Clock', color: '#B7802A' },
}

const KrStatusBadge = ({ status }: KrStatusBadgeProps) => {
  const badge = BADGES[status]
  return (
    <Stack
      horizontal
      verticalAlign="center"
      tokens={{ childrenGap: 6 }}
      styles={{
        root: {
          display: 'inline-flex',
          padding: '2px 10px',
          borderRadius: 12,
          border: `1px solid ${badge.color}`,
          backgroundColor: '#fff',
          whiteSpace: 'nowrap',
        },
      }}
    >
      <FontIcon iconName={badge.icon} aria-hidden="true" style={{ color: badge.color, fontSize: 12 }} />
      <Text variant="small" styles={{ root: { fontWeight: 600, color: '#323130' } }}>
        {badge.label}
      </Text>
    </Stack>
  )
}

export default KrStatusBadge
